import React from "react";
import { connect } from "react-redux";

class ShoppingBagNum extends React.Component {
  render() {
    const { myBagData, getMyBagSuccessfully } = this.props;
    
    return (
      <span className="shoppingBagNum">
        
        {getMyBagSuccessfully && myBagData.cartItems ?  myBagData.cartItems.length : "0"}
      </span>
    );
  }
}
const mapStateToProps = state => {
  return {
    getMyBagSuccessfully: state.myBag.getMyBagSuccessfully,
    myBagData: state.myBag.myBagData
  };
};
export default connect(
  mapStateToProps,
  null
)(ShoppingBagNum);
